

export const phoneNumber = "+237653815919"
export const phoneNumberFormat = "+237 653 815 919"
export const email = "contact@swiftech.cm"
export const localisation = "Rue Drouot Akwa Douala, Cameroun"
export const localisationLink = "https://maps.app.goo.gl/KQj5waxkyeHuXfhx6"